export const BranchMessages = {
  ERROR_LOADING_BRANCHES: 'Caro parceiro, foi encontrado um erro ao buscar a filial do seu ponto de venda. Por favor, tente novamente e caso o erro persista.',
  ERROR_EMPTY_BRANCHES: 'Caro parceiro, foi encontrado um erro ao buscar a filial do seu ponto de venda. Por favor, tente novamente e caso o erro persista, entre em contato com a Área de Suporte.'
}
